import classes from './CommonCard.module.css';

const CommonCard = ({ children, className, style }) => {
  return (
    <div className={`${classes.commonCard} ${className}`} style={style}>
      {children}
    </div>
  );
}
export default CommonCard;